import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=16ba49ed&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./Profile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Profile.vue?vue&type=style&index=0&id=16ba49ed&prod&lang=scss&scoped=true"
import style1 from "./Profile.vue?vue&type=style&index=1&id=16ba49ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba49ed",
  null
  
)

export default component.exports